module.exports = __webpack_public_path__ + "static/bv-76cd6249c41cd78a1d24fa448d7823da.png";